import ApiClient from "./ApiClient";
import Selectitem from "../models/shared/SelectItem";
import ValidityRangeReason from "../models/financing-request/validity-range/ValidityRangeReason";

export default class ValidityRangeReasonApiClient {
  apiClient: ApiClient;
  urlPrefix: string = "validity-range-reasons/";

  constructor() {
    this.apiClient = new ApiClient();
  }

  async getValidityRangeReasons() {
    const reasons = await this.apiClient.get(this.urlPrefix);

    return <Selectitem<ValidityRangeReason>[]>reasons;
  }
}
